// import enums
import { EndOfEmploymentSettlementEnums } from 'components/admin-portal/CLA/CLASettings/CLASettings.enums';

// import external libraries
import dayjs from 'dayjs';

// import types
import { SettlementFormValues } from './EndOfEmploymentSettlementsForm.types';
import { EndOfEmploymentSettlementResponse } from 'generated/index';

export const roundTo2 = (value?: number) =>
  Math.round((value ?? 0) * 100) / 100;

const formatHours = (
  value?: number,
  showPlusMinusHoursReversed = false
): string | number => {
  if (typeof value !== 'number' || value === 0) return '';
  const rounded = roundTo2(value);
  if (!showPlusMinusHoursReversed) return rounded;
  return value > 0 ? `-${rounded}` : `+${Math.abs(rounded)}`;
};

export const getDefaultValues = (
  row?: EndOfEmploymentSettlementResponse,
  showPlusMinusHoursReversed = false
): SettlementFormValues => ({
  name: row?.employment?.employeeName ?? '-',
  employmentNumber: row?.employment?.number ?? '-',
  organizationalUnitName: row?.employment?.organizationalUnitName ?? '-',
  functionName: row?.employment?.functionName ?? '-',
  endOfEmploymentSettlementDate: row?.endOfEmploymentSettlementDate
    ? dayjs(row.endOfEmploymentSettlementDate).format('DD-MM-YYYY')
    : '-',
  endOfEmploymentSettlementType:
    row?.defaultSettlementType ?? EndOfEmploymentSettlementEnums.TRANSFER,
  extraHours: +formatHours(row?.extraHours, showPlusMinusHoursReversed),
  leaveHours: roundTo2(row?.leaveHours),
  plbHours: roundTo2(row?.plbHours)
});
